import type { FC, SVGProps } from 'react'

import { DownTwo } from './DownTwo'
import { UpThree } from './UpThree'
import { UpTwo } from './UpTwo'

type SvgWave = FC<SVGProps<SVGSVGElement>>

export const variants: Record<string, SvgWave> = {
  down2: DownTwo,
  up2: UpTwo,
  up3: UpThree,
}
